import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useActiveTenantId } from '../lib/tenant';

/** 'live' = this council can send real email. 'preview' = a demonstration council: nothing is ever transmitted.
 *  'loading' until the council record is read. */
export type OutboundEmailModeView = 'live' | 'preview' | 'loading';

/**
 * Display-only. The SERVER enforces the mode (functions/src/outboundMode.ts, inside deliver()); this just lets screens say
 * so. Only the exact value 'live' counts as live: a missing, invalid, or unreadable setting reads as 'preview', matching
 * the server's fail-closed rule, so a screen can never imply mail is going out when it is not.
 */
export function useOutboundEmailMode(): OutboundEmailModeView {
  const tenantId = useActiveTenantId();
  const [state, setState] = useState<{ tenantId: string | null; mode: OutboundEmailModeView }>({ tenantId: null, mode: 'loading' });
  useEffect(() => {
    if (!tenantId) return;
    let cancelled = false;
    void getDoc(doc(db, 'tenants', tenantId))
      .then((snap) => { if (!cancelled) setState({ tenantId, mode: snap.data()?.outboundEmailMode === 'live' ? 'live' : 'preview' }); })
      .catch(() => { if (!cancelled) setState({ tenantId, mode: 'preview' }); });
    return () => { cancelled = true; };
  }, [tenantId]);
  return state.tenantId === tenantId && tenantId ? state.mode : 'loading';
}
